import { makeStyles } from "@material-ui/core/styles";

export const successPageStyles = makeStyles((theme) => ({
  confetti: {
    position: "absolute",
    width: "100%",
    height: "100%",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  formWrapper: {
    width: "100%",
    padding: "15px 40px",
    backgroundColor: "#FFFFFF",
    position: "relative",
  },
  loginContent: {
    width: "100%",
    backgroundColor: "#4187B6",
    minHeight: "100VH",
    background: `url("/fruition-icon-background.svg") repeat center center fixed;`,
  },
  wrapperLogin: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  logo: {
    marginBottom: theme.spacing(3),
    width: "100%",
  },
  loginLeftContent: {
    zIndex: 1,
    minHeight: "100VH",
    height: "100%",
    marginTop: 0,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    padding: theme.spacing(4),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "80%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "70%",
      maxWidth: "1200px",
    },
  },
  subscriptionMessage: {
    fontSize: "13px",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  ribbonImage: {
    position: "absolute",
    width: "20%",
    height: "150px !important",
    maxWidth: "250px !important",
    maxHeight: "150px !important",
    right: 0,
    left: 0,
    marginLeft: "auto",
    marginRight: "auto",
    [theme.breakpoints.only("xs")]: {
      top: theme.spacing(-10),
    },
    [theme.breakpoints.only("sm")]: {
      top: theme.spacing(-9),
    },
    [theme.breakpoints.only("md")]: {
      top: theme.spacing(-8),
    },
    [theme.breakpoints.up("lg")]: {
      top: theme.spacing(-8),
    },
  },
}));
